export function validatePricingBasePayload(payload) {
  if (!payload?.nationality) {
    return "La nacionalidad es obligatoria.";
  }

  if (
    payload?.priceKm === "" ||
    payload?.priceKm === null ||
    payload?.priceKm === undefined
  ) {
    return "El precio por kilometro es obligatorio.";
  }

  if (
    payload?.priceTime === "" ||
    payload?.priceTime === null ||
    payload?.priceTime === undefined
  ) {
    return "El precio por tiempo es obligatorio.";
  }

  if (
    payload?.priceBase === "" ||
    payload?.priceBase === null ||
    payload?.priceBase === undefined
  ) {
    return "El precio base es obligatorio.";
  }

  if (typeof payload?.active !== "boolean") {
    return "El estado activo es obligatorio.";
  }

  return null;
}
